import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommand} from "./abstract.command";
import {CarriesEntity} from "./carries-entity.interface";
import {CommandName} from "./command-name.enum";
import {RecolorContent} from "./payloads/recolor-content";

/**
 * Recolors an existing issue status: colour and text colour (feature plan 0074).
 *
 * ADR-016 action command: the payload is a `RecolorContent`, serialized by the generic path — no transformer.
 * The status itself travels as `entity` (`CarriesEntity`) for the local `entity.changed`.
 */
export class RecolorIssueStatusCommand extends AbstractCommand<RecolorContent> implements CarriesEntity<IssueStatus> {

    public name = CommandName.RECOLOR_ISSUE_STATUS;

    public tags: string[] = [`entity`, `update`, `issue-status`];

    /** @param changed the changed fields; only `color` and `textColor` among them are sent */
    constructor(public readonly entity: IssueStatus, changed: ReadonlyArray<string>) {
        super('issue-status', entity.uid, RecolorContent.of(entity, changed));
    }
}
